<header
  [ngClass]="
    isCompanyDashboard
      ? 'bg-tertiary text-white border-transparent'
      : 'bg-white text-black border-gray-100'
  "
  class="px-4 sm:px-6 h-[70px] py-3 flex items-center justify-between border-b w-full"
>
  <div class="flex items-center space-x-3 sm:space-x-4">
    <button
      (click)="goHome()"
      class="flex items-center justify-center cursor-pointer"
    >
      <img
        src="assets/icon/codijobs.png"
        class="h-10 sm:h-12"
        alt="Codijobs logo"
      />
      <span
        [ngClass]="isCompanyDashboard ? 'text-white' : 'text-primary'"
        class="font-bold text-lg select-none ml-2 hidden sm:inline"
      >
        Codijobs
      </span>
    </button>
    <nav
      [ngClass]="isCompanyDashboard ? 'text-gray-300' : 'text-gray-600'"
      class="hidden md:flex space-x-6 font-normal ml-6 lg:ml-10"
    >
      <a
        routerLink="/"
        routerLinkActive="font-semibold text-primary"
        [routerLinkActiveOptions]="{ exact: true }"
        class="transition"
      >
        Inicio
      </a>
      <a
        routerLink="/jobs"
        routerLinkActive="font-semibold text-primary"
        class="hover:text-primary transition"
      >
        Empleos
      </a>
      <a
        routerLink="/companies"
        routerLinkActive="font-semibold text-primary"
        class="hover:text-primary transition"
      >
        Compañías
      </a>
      <a
        routerLink="/pricing"
        routerLinkActive="font-semibold text-primary"
        class="hover:text-primary transition"
      >
        Paquetes
      </a>
    </nav>
  </div>
  <div class="flex items-center space-x-4 sm:space-x-6">
    @if(user){
    <div class="flex items-center space-x-4 sm:space-x-6">
      <div class="relative" tabindex="0">
        <button
          (click)="toggleNotificationMenu()"
          aria-label="Notificaciones"
          class="relative text-gray-400 transition text-xl cursor-pointer"
          [ngClass]="iconClass"
        >
          <ng-icon name="octBell" />
          <span
            *ngIf="notifications.length > 0"
            class="absolute top-0 right-0 block w-2 h-2 rounded-full bg-red-500"
          ></span>
        </button>
        <div
          *ngIf="notificationMenuOpen"
          (click)="notificationMenuOpen = false"
          class="fixed inset-0 z-40"
        ></div>
        <div
          *ngIf="notificationMenuOpen"
          class="absolute mt-2 w-72 sm:w-80 bg-white border border-gray-200 rounded-md shadow-lg z-50 max-h-96 overflow-y-auto right-0"
          (click)="$event.stopPropagation()"
        >
          <ng-container *ngIf="notifications.length === 0; else notifList">
            <div
              class="flex flex-col items-center justify-center text-center px-6 py-10 text-gray-500"
            >
              <ng-icon name="octBell" size="35" />
              <p class="font-medium mt-5">No tienes notificaciones nuevas</p>
              <p class="text-sm">
                Aquí aparecerán las novedades y alertas importantes.
              </p>
            </div>
          </ng-container>
          <ng-template #notifList>
            <div class="relative max-h-96 overflow-y-auto">
              <div
                *ngFor="let notif of notifications; let last = last"
                class="px-4 py-3"
                [class.border-b]="!last"
                [class.border-gray-200]="!last"
              >
                <div class="text-sm text-gray-600">
                  {{ notif.description }}
                </div>
                <div
                  class="flex justify-between items-center mt-1 text-xs text-gray-400"
                >
                  <span>Plataforma Codijobs</span>
                </div>
              </div>
              <div
                class="sticky bottom-0 bg-white border-t border-gray-200 p-2 flex justify-center"
              >
                <button
                  (click)="markAllAsRead(); $event.stopPropagation()"
                  [disabled]="loadingMarkRead"
                  class="relative cursor-pointer flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-600 hover:text-primary hover:bg-light rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed"
                  aria-label="Marcar todo como leído"
                >
                  <div
                    *ngIf="loadingMarkRead"
                    class="w-5 h-5 border-2 border-gray-300 border-t-primary rounded-full animate-spin"
                  ></div>
                  <ng-icon
                    *ngIf="!loadingMarkRead"
                    name="heroCheck"
                    size="18"
                  ></ng-icon>
                  Marcar todo como leído
                </button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
      <div
        class="relative"
        (click)="toggleUserMenu()"
        tabindex="0"
        (blur)="closeUserMenu()"
      >
        <img
          [src]="userImage"
          alt="Foto de perfil"
          class="w-9 h-9 sm:w-10 sm:h-10 rounded-full cursor-pointer border-2 border-transparent transition"
          [ngClass]="imageBorderClass"
        />
        @if(userMenuOpen){
        <div
          class="absolute right-0 mt-2 w-44 sm:w-48 bg-white border border-gray-200 rounded-md shadow-sm py-2 z-50"
        >
          <a
            href="/user/detail"
            class="block px-4 py-2 text-gray-700 hover:bg-blue-100 transition"
            >Mi Perfil</a
          >
          <a
            href="/user/company"
            class="block px-4 py-2 text-gray-700 hover:bg-blue-100 transition"
            >Compañía</a
          >
          <a
            href="/my-jobs"
            class="block px-4 py-2 text-gray-700 hover:bg-blue-100 transition"
            >Solicitudes</a
          >
          <button
            (click)="openConfirmLogout()"
            class="w-full text-left px-4 py-2 text-red-600 hover:bg-red-100 transition"
          >
            Cerrar sesión
          </button>
        </div>
        }
      </div>
      <button
        (click)="toggleMobileMenu()"
        aria-label="Menú"
        class="md:hidden text-gray-600 hover:text-blue-600 transition text-2xl"
      >
        <ng-icon name="heroBars3" />
      </button>
    </div>
    } @else{
    <div class="flex items-center gap-2 sm:gap-4">
      <a
        routerLink="/register"
        class="text-primary font-semibold px-3 py-1.5 rounded-md hover:underline transition text-base sm:text-base md:text-base"
      >
        Crear cuenta
      </a>
      <a
        routerLink="/login"
        class="border border-primary text-primary font-semibold px-3 py-1.5 rounded-md transition-transform duration-200 transform hover:scale-105 text-base sm:text-base md:text-base"
      >
        Iniciar sesión
      </a>
      <button
        (click)="toggleMobileMenu()"
        aria-label="Menú"
        class="md:hidden text-gray-600 hover:text-blue-600 transition text-2xl ml-1"
      >
        <ng-icon name="heroBars3" />
      </button>
    </div>
    }
  </div>
</header>
<div
  *ngIf="mobileMenuOpen"
  (click)="toggleMobileMenu()"
  class="fixed inset-0 z-40 bg-black/60 bg-opacity-50 md:hidden"
>
  <nav
    [ngClass]="{
      'translate-x-0': mobileMenuOpen,
      '-translate-x-full': !mobileMenuOpen
    }"
    class="fixed top-0 left-0 w-64 h-full bg-dark shadow-lg z-50 transition-transform duration-300 ease-in-out md:hidden flex flex-col pt-20"
  >
    <div class="px-6 pb-3 border-b border-gray-700 mb-10">
      <span class="font-bold text-2xl text-white">Codijobs</span>
    </div>
    <a
      routerLink="/"
      routerLinkActive="font-semibold text-primary bg-light"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="mobileMenuOpen = false"
      class="block px-6 py-3 text-gray-200 hover:bg-light hover:text-primary transition"
    >
      Inicio
    </a>
    <a
      routerLink="/jobs"
      routerLinkActive="font-semibold text-primary bg-light"
      (click)="mobileMenuOpen = false"
      class="block px-6 py-3 text-gray-200 hover:bg-light hover:text-primary transition"
    >
      Empleos
    </a>
    <a
      routerLink="/companies"
      routerLinkActive="font-semibold text-primary bg-light"
      (click)="mobileMenuOpen = false"
      class="block px-6 py-3 text-gray-200 hover:bg-light hover:text-primary transition"
    >
      Compañías
    </a>
    <a
      routerLink="/pricing"
      routerLinkActive="font-semibold text-primary bg-light"
      (click)="mobileMenuOpen = false"
      class="block px-6 py-3 text-gray-200 hover:bg-light hover:text-primary transition"
    >
      Paquetes
    </a>
  </nav>
</div>
<div
  *ngIf="confirmLogoutOpen"
  class="fixed inset-0 bg-black/60 flex items-center justify-center z-50"
>
  <div class="bg-white rounded-lg shadow-lg max-w-sm w-full p-6 text-center">
    <h2 class="text-lg font-semibold text-gray-800 mb-4">
      ¿Estás seguro que deseas cerrar sesión?
    </h2>
    <div class="flex justify-center gap-4">
      <button
        (click)="closeConfirmLogout()"
        [disabled]="loadingLogout"
        class="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
      >
        Cancelar
      </button>
      <app-loading-button
        [text]="'Cerrar sesión'"
        [loading]="loadingLogout"
        type="button"
        (click)="confirmLogout()"
      ></app-loading-button>
    </div>
  </div>
</div>
